export default {
      id: "user-usage",
      viewBox: "0 0 16 18",
      url: __webpack_public_path__ + "img/icons.f759dcb6.svg#user",
      toString: function () {
        return this.url;
      }
    }